import { Box, Typography, CircularProgress, Button } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";
import { getPlgSDSPSetpointsBtn } from "../../utils/wellsConfig";
import { ProgressDialog } from "../plungerPage/progressPopup";

const SpeedItems = [
  {
    items: [
      {
        label: "Speed",
        liveValue: 12.3,
        unit: "RPM",
      },
      {
        label: "System Volts",
        liveValue: 12.3,
        unit: "VDC",
      },
      {
        label: "Field Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },
      {
        label: "Inter Stage Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },

      {
        label: "Main Discharge Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },
      {
        label: "Suction Scrubber Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },
      {
        label: "Compressor Oil Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },
    ],
  },
];
const PIDItems = [
  {
    items: [
      {
        label: "Field Prs PID",
        liveValue: 12.3,
        unit: "%",
      },
      {
        label: "Discharge Prs PID",
        liveValue: 12.3,
        unit: "%",
      },

      {
        label: "Suction Scrubber PID",
        liveValue: 12.3,
        unit: "%",
      },

      {
        label: "Flow Incremental PID",
        liveValue: 12.3,
        unit: "%",
      },
    ],
  },
];
const TempItemsC5 = [
  {
    items: [
      {
        label: "Main Flow Rate",
        liveValue: 12.3,
        unit: "MCF",
      },
      {
        label: "Discharge Temp",
        liveValue: 12.3,
        unit: "F",
      },

      {
        label: "Discharge #2 Temp",
        liveValue: 12.3,
        unit: "F",
      },

      {
        label: "Engine Oil Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },
      {
        label: "Engine Manifold Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },
      {
        label: "Engine Coolant Temp",
        liveValue: 12.3,
        unit: "F",
      },
      {
        label: "Ambient Temp",
        liveValue: 12.3,
        unit: "F",
      },
      {
        label: "Tali Shaft Temp",
        liveValue: 12.3,
        unit: "F",
      },
      {
        label: "TGT RPM",
        liveValue: 12.3,
        unit: "RPM",
      },
      {
        label: "Proptional % Close",
        liveValue: 12.3,
        unit: "%",
      },
    ],
  },
];
const TempItemsC5E = [
  {
    items: [
      {
        label: "Main Flow Rate",
        liveValue: 12.3,
        unit: "MCF",
      },
      {
        label: "Discharge Temp",
        liveValue: 12.3,
        unit: "F",
      },

      {
        label: "Discharge #2 Temp",
        liveValue: 12.3,
        unit: "F",
      },

      {
        label: "Main Motor Speed",
        liveValue: 12.3,
        unit: "RPM",
      },
      {
        label: "Compressor Main Motor Amps",
        liveValue: 12.3,
        unit: "AMP",
      },
      {
        label: "Compressor Cooler Motor Amps",
        liveValue: 12.3,
        unit: "AMP",
      },
      {
        label: "Ambient Temp",
        liveValue: 12.3,
        unit: "F",
      },
      {
        label: "Tali Shaft Temp",
        liveValue: 12.3,
        unit: "F",
      },
      {
        label: "TGT RPM",
        liveValue: 12.3,
        unit: "RPM",
      },
      {
        label: "Proptional % Close",
        liveValue: 12.3,
        unit: "%",
      },
    ],
  },
];
const registers = [
  "_40927",
  "_40928",
  "_40929",
  "_40931",
  "_40806",
  "_40845",
  "_40846",
  "_40935",
  "_40936",
  "_40938",
  "_40952",
  "_40847",
  "_40934",
  "_40852",
  "_40812",
  "_40813",
  "_40814",
];

export default function FaultSnapshotsC5(selectedDevice) {
  const [loading, setLoading] = useState(true);
  const [speedData, setSpeedData] = useState(SpeedItems);
  const [PIDData, setPIDData] = useState(PIDItems);
  const [TempData, setTempData] = useState([]);
  const [engineType, setEngineType] = useState("");
  const [progressOpen, setProgressOpen] = useState(false);
  const [progressSuccess, setProgressSuccess] = useState(false);
  const [progressError, setProgressError] = useState("");
  const fetchData = async () => {
    try {
      setLoading(true);
      const [regResp, engResp] = await Promise.all([
        axios.post(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${selectedDevice.selectedDevice.device.id}`,
          registers,
        ),
        axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/engine-data/${selectedDevice.selectedDevice.device.id}`,
        ),
      ]);

      const regData = regResp.data.data.response;
      const engData = engResp.data.response;
      const updatedSpeed = speedData.map((group) => ({
        ...group,
        items: group.items.map((it) => {
          let updatedLiveValue = it.liveValue;

          switch (it.label) {
            case "Speed":
              updatedLiveValue = engData.ENGINE_SPEED;
              break;
            case "System Volts":
              updatedLiveValue = engData.SYSTEM_VOTLS;
              break;
            case "Field Pressure":
              updatedLiveValue = engData.FIELD_PRES;
              break;
            case "Inter Stage Pressure":
              updatedLiveValue = engData.INTERSTAGE_PRES;
              break;
            case "Main Discharge Pressure":
              updatedLiveValue = engData.DISCHARGE_PRES;
              break;
            case "Suction Scrubber Pressure":
              updatedLiveValue = engData.SUCTION_PRES;
              break;
            case "Compressor Oil Pressure":
              updatedLiveValue = engData.COMP_OIL_PRES;
              break;
          }

          return {
            ...it,
            liveValue: updatedLiveValue,
          };
        }),
      }));

      setSpeedData(updatedSpeed);

      const updatedPID = PIDData.map((group) => ({
        ...group,
        items: group.items.map((it) => {
          let updatedLiveValue = it.liveValue;

          switch (it.label) {
            case "Field Prs PID":
              updatedLiveValue = regData["_40927"] / 100;
              break;
            case "Discharge Prs PID":
              updatedLiveValue = regData["_40928"] / 100;
              break;
            case "Suction Scrubber PID":
              updatedLiveValue = regData["_40931"] / 100;
              break;
            case "Flow Incremental PID":
              updatedLiveValue = regData["_40929"] / 100;
              break;
          }

          return {
            ...it,
            liveValue: updatedLiveValue,
          };
        }),
      }));

      setPIDData(updatedPID);

      const engineTypeValue = engResp.data.type;
      setEngineType(engineTypeValue);

      let baseTemplate = engineTypeValue === "C5" ? TempItemsC5 : TempItemsC5E;

      const updatedTemp = baseTemplate.map((group) => ({
        ...group,
        items: group.items.map((it) => {
          let v = it.liveValue;

          if (engineTypeValue === "C5") {
            switch (it.label) {
              case "Main Flow Rate":
                v = regData["_40806"] / 10;
                break;
              case "Discharge Temp":
                v = regData["_40845"] / 10;
                break;
              case "Discharge #2 Temp":
                v = regData["_40846"] / 10;
                break;
              case "Engine Oil Pressure":
                v = regData["_40935"];
                break;
              case "Engine Manifold Pressure":
                v = regData["_40936"];
                break;
              case "Engine Coolant Temp":
                v = regData["_40938"];
                break;
              case "Ambient Temp":
                v = regData["_40852"] / 10;
                break;
              case "Tali Shaft Temp":
                v = regData["_40847"] / 10;
                break;
              case "TGT RPM":
                v = regData["_40812"];
                break;
              case "Proptional % Close":
                v = regData["_40934"] / 100;
                break;
            }
          }

          if (engineTypeValue === "C5E") {
            switch (it.label) {
              case "Main Flow Rate":
                v = regData["_40806"] / 10;
                break;
              case "Discharge Temp":
                v = regData["_40845"] / 10;
                break;
              case "Discharge #2 Temp":
                v = regData["_40846"] / 10;
                break;
              case "Main Motor Speed":
                v = regData["_40812"];
                break;
              case "Compressor Main Motor Amps":
                v = regData["_40813"];
                break;
              case "Compressor Cooler Motor Amps":
                v = regData["_40814"];
                break;
              case "Ambient Temp":
                v = regData["_40852"] / 10;
                break;
              case "Tailshaft Temp":
                v = regData["_40847"] / 10;
                break;
              case "TGT RPM":
                v = regData["_40812"];
                break;
              case "Proptional % Close":
                v = regData["_40934"] / 100;
                break;
            }
          }

          return { ...it, liveValue: v ?? 0 };
        }),
      }));

      setTempData(updatedTemp);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedDevice.selectedDevice.device?.id) return;
    fetchData();
  }, [selectedDevice.selectedDevice.device?.id]);

  return (
    <Box sx={{ width: "100%", maxWidth: "100vw" }}>
      {/* HEADER */}
      <Box
        sx={{
          bgcolor: "#1e293b",
          px: 2,
          py: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography sx={{ color: "#ffffffff", fontSize: 14 }}>
          Fault Snapshots
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            justifyContent: "flex-end",
            flexGrow: 1,
          }}
        >
          <Button
            color="primary"
            variant="contained"
            size="small"
            sx={{ fontSize: 12 }}
            onClick={() =>
              getPlgSDSPSetpointsBtn(
                selectedDevice.selectedDevice.device?.id,
                registers,
                "P,800,8,811,3,926,3,930,1,934,2,937,1,851,1,844,3,933,1",
                setProgressSuccess,
                setProgressError,
                setProgressOpen,
              )
            }
          >
            Get Setpoints
          </Button>
        </Box>
      </Box>

      {/* CONTENT */}
      {loading ? (
        <Box
          sx={{
            height: "300px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <CircularProgress />
          <Typography sx={{ color: "#94a3b8", fontSize: 13 }}>
            Loading fault snapshots...
          </Typography>
        </Box>
      ) : (
        <Box sx={{ p: 2 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr", // mobile: single column
                sm: "1fr 1fr", // tablet: 2 columns
                md: "1fr 1fr", // desktop: 2 columns
              },
              gap: 2,
            }}
          >
            {/* LEFT COLUMN */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              {/* SPEED CARD */}
              <Box sx={{ bgcolor: "#1e293b", borderRadius: 2, p: 2 }}>
                <Typography sx={{ color: "white", mb: 1, fontWeight: "bold" }}>
                  Speed / Pressure
                </Typography>

                {speedData[0].items.map((item, i) => (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      py: 0.5,
                      borderBottom: "1px solid #334155",
                    }}
                  >
                    <Typography sx={{ color: "#cbd5f5", fontSize: 13 }}>
                      {item.label}
                    </Typography>
                    <Typography sx={{ color: "#38bdf8", fontWeight: "bold" }}>
                      {item.liveValue} {item.unit}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* PID CARD */}
              <Box sx={{ bgcolor: "#1e293b", borderRadius: 2, p: 2 }}>
                <Typography sx={{ color: "white", mb: 1, fontWeight: "bold" }}>
                  PID
                </Typography>

                {PIDData[0].items.map((item, i) => (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      py: 0.5,
                      borderBottom: "1px solid #334155",
                    }}
                  >
                    <Typography sx={{ color: "#cbd5f5", fontSize: 13 }}>
                      {item.label}
                    </Typography>
                    <Typography sx={{ color: "#38bdf8", fontWeight: "bold" }}>
                      {item.liveValue} {item.unit}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>

            {/* RIGHT COLUMN */}
            <Box sx={{ bgcolor: "#1e293b", borderRadius: 2, p: 2 }}>
              <Typography sx={{ color: "white", mb: 1, fontWeight: "bold" }}>
                Temperature / Flow / Engine
              </Typography>

              {TempData[0].items.map((item, i) => (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    py: 0.5,
                    borderBottom: "1px solid #334155",
                  }}
                >
                  <Typography sx={{ color: "#cbd5f5", fontSize: 13 }}>
                    {item.label}
                  </Typography>
                  <Typography sx={{ color: "#38bdf8", fontWeight: "bold" }}>
                    {item.liveValue} {item.unit}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      )}
      <ProgressDialog
        open={progressOpen}
        isSuccess={progressSuccess}
        errorMessage={progressError}
        onClose={() => {
          setProgressOpen(false);
          setProgressError("");
        }}
        onRefresh={async () => {
          setProgressOpen(false);
          setProgressError("");
          await fetchData();
        }}
        loadingMessage="Check Device Response. Operation in-progress ..."
        successMessage="Successfully updated!"
      />
    </Box>
  );
}
